export default "__VITE_ASSET__CSt3iRDV__"